"use client";

import { useState } from "react";
import { FileText, Download } from "lucide-react";

const FreePDFSection: React.FC = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleDownload = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage("");

    try {
      const response = await fetch("/api/referrals-tutorial/download-pdf", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage("✓ Check your email! The PDF structure guide is on its way. (Check spam folder if you don't see it)");
        setEmail("");

        // Track download event
        if (typeof window !== 'undefined' && (window as any).gtag) {
          (window as any).gtag('event', 'pdf_download', {
            event_category: 'engagement',
            event_label: 'referrals_tutorial_structure'
          });
        }
      } else {
        setMessage(data.error || "Something went wrong. Please try again.");
      }
    } catch (error) {
      setMessage("Failed to send. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="bg-gray-900 text-white py-16 px-4 border-t border-cyan-400/20">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center justify-center mb-6">
          <FileText className="text-cyan-400 mr-3" size={40} />
          <h2 className="text-3xl md:text-4xl font-bold text-center">
            Free: System Structure PDF
          </h2>
        </div>

        <p className="text-lg text-gray-300 mb-6 text-center">
          Not ready to buy? Get the free PDF that explains the complete architecture, database schema, and API structure. See exactly what you'll build before purchasing.
        </p>

        <form onSubmit={handleDownload} className="max-w-md mx-auto">
          <div className="flex flex-col sm:flex-row gap-3">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              className="flex-1 px-4 py-3 rounded-lg bg-gray-800 border border-gray-700 text-white placeholder-gray-400 focus:outline-none focus:border-cyan-400"
            />
            <button
              type="submit"
              disabled={isLoading}
              className={`bg-cyan-400 hover:bg-cyan-300 text-black font-semibold py-3 px-6 rounded-lg transition-all flex items-center justify-center ${
                isLoading ? "opacity-60 cursor-not-allowed" : ""
              }`}
            >
              {isLoading ? (
                "Sending..."
              ) : (
                <>
                  <Download size={20} className="mr-2" />
                  Get PDF
                </>
              )}
            </button>
          </div>

          {message && (
            <p className={`mt-4 text-center text-sm ${
              message.startsWith("✓") ? "text-green-400" : "text-red-400"
            }`}>
              {message}
            </p>
          )}
        </form>

        <p className="text-xs text-gray-500 mt-4 text-center">
          No spam. Just the PDF sent to your inbox instantly.
        </p>
      </div>
    </section>
  );
};

export default FreePDFSection;
